import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { breakpointColumns, ColumnWidth, AspectRatio } from '@knorr-bremse-portals/ngx-components';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

function mapSizes(width) {
    let sizes = '';
    for (const entry of Object.entries(breakpointColumns)) {
        if (entry[0] === 'default') {
            continue;
        }
        sizes += `${entry[0]} ${Math.min(width / entry[1] * 100, 100)}vw,`;
    }
    sizes += `${Math.min(width / breakpointColumns['default'] * 100, 100)}vw`;
    return sizes;
}
const sizes = {
    [ColumnWidth.Full]: mapSizes(ColumnWidth.Full),
    [ColumnWidth.Wider]: mapSizes(ColumnWidth.Wider),
    [ColumnWidth.Wide]: mapSizes(ColumnWidth.Wide),
    [ColumnWidth.Half]: mapSizes(ColumnWidth.Half),
    [ColumnWidth.Narrow]: mapSizes(ColumnWidth.Narrow),
    [ColumnWidth.OneFourth]: mapSizes(ColumnWidth.OneFourth),
    [ColumnWidth.OneSixth]: mapSizes(ColumnWidth.OneSixth),
    [ColumnWidth.OneTwelth]: mapSizes(ColumnWidth.OneTwelth),
};
class PictureComponent {
    constructor() {
        this.variants = [{
                aspectRatio: AspectRatio.Standard,
            }];
    }
    ngOnInit() {
        this.fallbackVariant = this.getFallbackVariant();
        this.fallbackSource = this.getFallbackSource();
        this.sizes = sizes[this.rootColumns];
    }
    toSrcsetString(srcset) {
        return Object.entries(srcset)
            .filter(([width]) => width !== '?')
            .map(([width, src]) => `${src} ${width}w`)
            .join(', ');
    }
    getFallbackVariant() {
        // TODO: update this with BreakpointObserver
        return this.variants.find(variant => variant.mediaQuery === undefined) ?? this.variants[this.variants.length - 1];
    }
    getFallbackSourceSet() {
        const fallbackAspectRatio = this.getFallbackVariant().aspectRatio;
        return this.picture[fallbackAspectRatio] ?? Object.values(this.picture)[0];
    }
    getFallbackSource() {
        const srcset = this.getFallbackSourceSet();
        const widths = Object.keys(srcset);
        const fallbackWidth = widths[widths.length - 1];
        return srcset[fallbackWidth];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: PictureComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: PictureComponent, isStandalone: true, selector: "kb-picture", inputs: { variants: "variants", rootColumns: "rootColumns", picture: "picture", alt: "alt", draggable: "draggable", aboveFold: "aboveFold" }, ngImport: i0, template: "<picture [attr.aspect-ratio]=\"fallbackVariant.aspectRatio\">\n  <source *ngFor=\"let variant of variants\" [srcset]=\"picture[variant.aspectRatio] !== undefined ? toSrcsetString(picture[variant.aspectRatio]!) : ('missing picture variant ' + variant.aspectRatio)\" [attr.media]=\"variant.mediaQuery\" [attr.sizes]=\"sizes\">\n  <img [attr.loading]=\"aboveFold ? null : 'lazy'\" [attr.fetchpriority]=\"aboveFold ? 'high' : null\" [src]=\"fallbackSource\" [alt]=\"alt\" [attr.draggable]=\"draggable\">\n</picture>\n", styles: [":host img,:host picture{display:block;width:100%}:host[restrict-size=height] img,:host[restrict-size=height] picture{height:100%;width:auto}:host img{aspect-ratio:inherit;object-fit:contain}:host picture[aspect-ratio=\"1x1\"]{aspect-ratio:1/1}:host picture[aspect-ratio=\"16x9\"]{aspect-ratio:16/9}:host picture[aspect-ratio=\"384x143\"]{aspect-ratio:384/143}:host picture[aspect-ratio=\"636x175\"]{aspect-ratio:636/175}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: PictureComponent, decorators: [{
            type: Component,
            args: [{ selector: 'kb-picture', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [CommonModule], template: "<picture [attr.aspect-ratio]=\"fallbackVariant.aspectRatio\">\n  <source *ngFor=\"let variant of variants\" [srcset]=\"picture[variant.aspectRatio] !== undefined ? toSrcsetString(picture[variant.aspectRatio]!) : ('missing picture variant ' + variant.aspectRatio)\" [attr.media]=\"variant.mediaQuery\" [attr.sizes]=\"sizes\">\n  <img [attr.loading]=\"aboveFold ? null : 'lazy'\" [attr.fetchpriority]=\"aboveFold ? 'high' : null\" [src]=\"fallbackSource\" [alt]=\"alt\" [attr.draggable]=\"draggable\">\n</picture>\n", styles: [":host img,:host picture{display:block;width:100%}:host[restrict-size=height] img,:host[restrict-size=height] picture{height:100%;width:auto}:host img{aspect-ratio:inherit;object-fit:contain}:host picture[aspect-ratio=\"1x1\"]{aspect-ratio:1/1}:host picture[aspect-ratio=\"16x9\"]{aspect-ratio:16/9}:host picture[aspect-ratio=\"384x143\"]{aspect-ratio:384/143}:host picture[aspect-ratio=\"636x175\"]{aspect-ratio:636/175}\n"] }]
        }], propDecorators: { variants: [{
                type: Input
            }], rootColumns: [{
                type: Input,
                args: [{ required: true }]
            }], picture: [{
                type: Input,
                args: [{ required: true }]
            }], alt: [{
                type: Input,
                args: [{ required: true }]
            }], draggable: [{
                type: Input
            }], aboveFold: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { PictureComponent };
